var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvoMenuActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2486 4.09551C12.796 4.09551 13.321 4.31297 13.7081 4.70004C14.0952 5.08711 14.3126 5.61209 14.3126 6.1595V11.6635C14.3126 12.2109 14.0952 12.7358 13.7081 13.1229C13.321 13.51 12.796 13.7274 12.2486 13.7274H8.47365L5.36868 15.7914V13.7274H3.9927C3.44529 13.7274 2.92031 13.51 2.53324 13.1229C2.14617 12.7358 1.92871 12.2109 1.92871 11.6635V6.1595C1.92871 5.61209 2.14617 5.08711 2.53324 4.70004C2.92031 4.31297 3.44529 4.09551 3.9927 4.09551H12.2486Z",
    fill: "#6860ee",
    stroke: "#6860ee",
    strokeWidth: 0.88563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3689 7.53548H10.8729ZM5.3689 10.2875H8.77908Z",
    fill: "#6860ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3689 7.53548H10.8729M5.3689 10.2875H8.77908",
    stroke: "#E8F1FF",
    strokeWidth: 1.15132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8479 10.5028C11.4984 10.5028 11.1632 10.6269 10.9161 10.8478C10.669 11.0687 10.5302 11.3683 10.5302 11.6806V14.8215C10.5302 15.1339 10.669 15.4335 10.9161 15.6544C11.1632 15.8753 11.4984 15.9994 11.8479 15.9994L13.6788 15.9994L15.8749 17.1772V15.9994H16.7534C17.1028 15.9994 17.438 15.8753 17.6851 15.6544C17.9322 15.4335 18.071 15.1339 18.071 14.8215V11.6806C18.071 11.3682 17.9322 11.0687 17.6851 10.8478C17.438 10.6269 17.1028 10.5028 16.7534 10.5028L11.8479 10.5028Z",
    fill: "#6860ee",
    stroke: "#E8F1FF",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8323 12.5127H12.5547ZM15.8323 14.1515H13.3741Z",
    fill: "#6860ee"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8323 12.5127H12.5547M15.8323 14.1515H13.3741",
    stroke: "#E8F1FF",
    strokeWidth: 0.748969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvoMenuActiveIcon);
export default __webpack_public_path__ + "static/media/convo-menu-active-icon.ccf6b648f43bb97d50dadf9dfa6b1fb8.svg";
export { ForwardRef as ReactComponent };